module.exports = __webpack_public_path__ + "img/toggle-right.febc472e.svg";